/*
Copyright 2026 AB Civil Consulting

Simplified annotation types - Slack Huddle Style
- Pen strokes only (no shapes, text, arrows)
- Auto-vanishing after 3 seconds
- Fixed per-user colors
*/

export interface Point {
  x: number;
  y: number;
  t?: number; // timestamp for latency compensation
}

// Simplified stroke - only pen with auto-vanish
export interface Stroke {
  id: string;
  points: Point[];
  color: string;
  size: number;
  userId: string;
  userName?: string;
  trackId?: string;
  sessionId?: string;
  createdAt: number;
  tool?: "vanishing"; // all strokes are vanishing
}

// Simplified message types
export type AnnotationMessage =
  | { type: "stroke"; stroke: Stroke }
  | { type: "points"; strokeId: string; points: Point[]; userId: string; color: string; size: number; trackId?: string; sessionId?: string; tool?: string }
  | { type: "clear"; userId?: string; trackId?: string; sessionId?: string }
  | { type: "undo"; userId: string; trackId?: string }
  | { type: "sync-request"; trackId?: string; sessionId?: string }
  | { type: "sync-response"; strokes: Stroke[]; sessionId?: string }
  | { type: "session-end"; trackId: string; sessionId: string; userId: string; timestamp: number };

export const VANISH_DURATION = 6000; // 6 seconds
export const DEFAULT_STROKE_SIZE = 4;
export const ANNOTATION_TOPIC = "ec.annotation";
